import { PrintType, Size, SizePx } from '@/types';
import { ensureSizeMm } from './convertSize';
import { scaleSize } from './scaleSize';

export const convertAndScale = (size: Size | SizePx, scale: number, printType: PrintType): Size =>
  scaleSize(ensureSizeMm(size, printType), scale);
